import { useState, useEffect } from "react";
import { fetchHistory } from "../api";

export default function History({ refresh }) {
  const [history, setHistory] = useState([]);

  useEffect(() => {
    fetchHistory()
      .then(res => setHistory(res.data))
      .catch(err => {
        console.error("Error fetching history:", err);
        alert("Failed to load claim history. Try again later.");
      });
  }, [refresh]);

  return (
    <div>
      <h3>Claim History</h3>
      <table border="1" cellPadding="6">
        <thead>
          <tr>
            <th>User</th>
            <th>Points</th>
            <th>Time</th>
          </tr>
        </thead>
        <tbody>
          {history.map((entry, index) => (
            <tr key={index}>
              <td>{entry.userId.name}</td>
              <td>{entry.points}</td>
              <td>{new Date(entry.claimedAt).toLocaleString()}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
